module.exports = __webpack_public_path__ + "img/about.f6c192ed.jpg";